import React from "react";
import { useTypedSelector } from "../../state/store";

var AnswerLockedComponent = function AnswerLockedComponent(_a) {
  var options = _a.options,
      quizItemId = _a.quizItemId;
  var quizItemAnswer = useTypedSelector(function (state) {
    return state.quizAnswer.quizAnswer.itemAnswers.find(function (o) {
      return o.quizItemId === quizItemId;
    });
  });
  var correctOption = options.find(function (o) {
    return o.correct;
  });
  var answeredCorrectly = quizItemAnswer === null || quizItemAnswer === void 0 ? void 0 : quizItemAnswer.optionAnswers.find(function (oa) {
    return correctOption && correctOption.id == oa.quizOptionId;
  });
  var selectedOptionId = ((quizItemAnswer === null || quizItemAnswer === void 0 ? void 0 : quizItemAnswer.optionAnswers.map(function (oa) {
    return oa.quizOptionId;
  })) || [])[0];
  var selectedOption = useTypedSelector(function (state) {
    var _a, _b;

    return (_b = (_a = state.quiz) === null || _a === void 0 ? void 0 : _a.items.find(function (o) {
      return o.id === quizItemId;
    })) === null || _b === void 0 ? void 0 : _b.options.find(function (o) {
      return selectedOptionId && o.id === selectedOptionId;
    });
  });

  if (!correctOption) {
    return React.createElement("div", null, "Question has no correct option");
  }

  if (!quizItemAnswer) {
    return React.createElement("div", null, "Nothing selected on this question. Maybe this was added after your answer?");
  }

  if (answeredCorrectly) {
    return React.createElement("div", null, correctOption.title);
  }

  return React.createElement(React.Fragment, null, React.createElement("div", null, "You chose: ", (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.title) || "unknown"), React.createElement("div", null, "Correct: ", correctOption.title));
};

export default AnswerLockedComponent;